import { ISession } from '../../models/session';
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { EmptyObservable } from 'rxjs/observable/EmptyObservable';
import { environment as config } from '../../../environments/environment';
import { AuthHttp } from 'angular2-jwt';
import { AuthService } from '../auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { BasicService } from '../../providers/basic';
import { IEmail } from '../../models/email';
import { isEmpty, omit } from 'ramda/es';
import * as moment from 'moment';
import { append } from 'ramda';
@Injectable()
export class EmailService extends BasicService {
  private API = config.emails.url;
  constructor(
    protected auth: AuthService,
    protected translate: TranslateService,
    private http: AuthHttp
  ) {
    super(auth, translate);
  }

  public getAll(session: ISession): Observable<Array<IEmail>> {
    return this.http
      .get(`${this.API}/sessions/${session.id}/mails?language=${session.language}`)
      .map(response => response.json())
      .catch(err => this.handleError(err));
  }

  public getMailingList(session: ISession, type: string): Observable<Array<string>> {
    return this.http
      .get(`${this.API}/sessions/${session.id}/mails/${type}/mailing?language=${session.language}`)
      .map(response => response.json())
      .map(response => response.emails)
      .catch(err => this.handleError(err));
  }

  public getMailingListSent(session: ISession, type: string): Observable<Array<string>> {
    return this.http
      .get(`${this.API}/sessions/${session.id}/mails/${type}/mailing/sent?language=${session.language}`)
      .map(response => response.json())
      .map(response => response.emails_list)
      .catch(err => this.handleError(err));
  }

  public getMailingListToSend(session: ISession, type: string): Observable<Array<string>> {
    return this.http
      .get(`${this.API}/sessions/${session.id}/mails/${type}/mailing/tosend?language=${session.language}`)
      .map(response => response.json())
      .map(response => response.emails_list)
      .catch(err => this.handleError(err));
  }

  public saveMailingList(
    session: ISession,
    email: IEmail,
    mailingList: Array<string>
  ): Observable<Array<string>> {
    const payload = {
      emails: mailingList
    };
    return this.http
      .put(
        `${this.API}/sessions/${session.id}/mails/${email.type}/mailing/edit?language=${
          session.language
        }`,
        payload
      )
      .map(response => response.json())
      .catch(err => this.handleError(err));
  }

  public removeMailingList(
    session: ISession,
    email: IEmail,
    mailingList: Array<string>
  ): Observable<Array<string>> {
    const payload = {
      emails: mailingList
    };
    return this.http
      .put(
        `${this.API}/sessions/${session.id}/mails/${email.type}/mailing/remove?language=${
          session.language
        }`,
        payload
      )
      .map(response => response.json())
      .catch(err => this.handleError(err));
  }
  public saveEmail(session: ISession, email: IEmail): Observable<Array<any>> {
    // stip scheduleat if date not valid
    const toSkip = ['type', ...(email.scheduleat && moment(email.scheduleat).isValid() ? [] : ['scheduleat'])];
    const payload = {
      sessionType: session.types.sessionType,
      content: omit(toSkip, email)
    };
    return this.http
      .put(
        `${this.API}/sessions/${session.id}/mails/${email.type}?language=${session.language}`,
        payload
      )
      .map(response => response.json())
      .catch(err => this.handleError(err));
  }

  // public saveAllEmailInformations(
  //   session: ISession,
  //   data: { email: IEmail; mailingList: Array<string> },
  //   notify: boolean
  // ): Observable<any> {
  //   return this.saveEmail(session, data.email)
  //     .flatMap(() => {
  //       return data.email.hasMailingList
  //         ? this.saveMailingList(session, data.email, data.mailingList)
  //         : Observable.of({});
  //     })
  //     .catch(err => this.handleError(err));
  // }

  public sendMail(session: ISession, type: string) {
    return this.http.get(
      `${this.API}/sessions/${session.id}/mails/${type}/send?language=${session.language}`
    );
  }

  public reSendMail(session: ISession, type: string) {
    return this.http.get(
      `${this.API}/sessions/${session.id}/mails/${type}/resend?language=${session.language}`
    );
  }

  public sendTestEmail(session: ISession, type: string, mailAddress: string): Observable<any> {
    const payload = {
      email: mailAddress
    };
    return this.http.post(
      `${this.API}/sessions/${session.id}/mails/${type}/send/test?language=${session.language}`,
      payload
    );
  }

  public sendOndemandEmail(session: ISession, type: string, mailingList: Array<string>): Observable<any> {
    const payload = {
      emails: mailingList
    };
    return this.http.post(
      `${this.API}/sessions/${session.id}/mails/${type}/send/ondemand?language=${session.language}`,
      payload
    );
  }

  public retrieveMailPreview(session: ISession, type: string): Observable<any> {
    return this.http
      .get(`${this.API}/sessions/${session.id}/mails/${type}/preview?language=${session.language}`)
      .map(response => response.json())
      .catch(err => this.handleError(err));
  }

  public applyEmailTemplate(session: ISession, data: any): Observable<any> {
    return this.http
      .post(`${this.API}/sessions/${session.id}/mails/templates?language=${session.language}`, data)
      .map(response => response.json())
      .catch(err => this.handleError(err));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/email/email.service.ts